videojs.addLanguage('ru', {
  "Share settings": "Поделиться",
  "Share button": "Поделиться",
  "Share link": "ссылка на видео",
  "Share link copy": "копировать",
  "Share iframe": "iframe",
  "Share generate": "генерировать код",
  "Share copy code": "копировать код",
  "Share other size": "Другой размер",
  "Share error": "Ошибка. Проверьте данные и попробуйте снова.",
  "Share copied": "скопировано"
});